import { InvestmentData } from "@/utils/types/NPS/Stepper/Investment";
import { put } from "@/services/axiosUitils";

const baseUrl = "/nps/registration";

class InvestmentService {
  createInvestment = async (
    ackId: string,
    payload: InvestmentData,
    nextStep?: string
  ): Promise<any> => {
    const response = await put<any>(
      `${baseUrl}/${ackId}/${nextStep}/`,
      payload,
      {}
    );
    return response;
  };
}

const instance = new InvestmentService();
export default instance;
